module.exports = __webpack_public_path__ + "0902662931e8ef36b5b4ac4b0278da6c.svg";